export const cookieConfig = {
  domain: 'idealagent.com',
  path: '/'
}

export const cookieNames = { location: 'location', preference: 'preference' }
export const cookieDayLength = 1
